import { render, staticRenderFns } from "./dialog-contract-xuqian.vue?vue&type=template&id=a68ba4c6&scoped=true&"
import script from "./dialog-contract-xuqian.vue?vue&type=script&lang=js&"
export * from "./dialog-contract-xuqian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a68ba4c6",
  null
  
)

export default component.exports